import * as styles from "./styles.module.scss"
import Item from "./Item"
import React, { useRef } from "react"
import Superscript from "../../Superscript"
import useIntersection from "../../../hooks/use-intersection"
import useThreshold from "../../../hooks/use-threshold"

const Timeline: React.FC = () => {
  const sun = useRef(null)
  const sunDisk = useRef(null)
  const shadow = useRef(null)
  const timeline = useRef(null)
  const track = useRef(null)
  const sky = useRef(null)

  const getScrolledDistanceSun = () => {
    const scrolledSky = sky.current.offsetTop
    const scrollableTrack =
      track.current.offsetHeight - sky.current.offsetHeight
    const percentage = (scrolledSky / scrollableTrack) * 100
    makeSunrise(percentage)
  }

  const makeSunrise = (percentage) => {
    const sunScale = percentage / 200 + 0.5
    const sunTranslate = 300 - percentage * 3
    const sunOpacity = percentage / 200 + 0.5
    const shadowSize = percentage / 200 + 0.5
    sunDisk.current.style.transform = `scale(${sunScale})`
    sun.current.style.transform = `translateY(${
      sunTranslate < 0 ? 0 : sunTranslate
    }%)`
    sun.current.style.opacity = sunOpacity
    shadow.current.style.transform = `scaleX(${shadowSize})`
  }

  const options = {
    threshold: useThreshold(100),
  }

  useIntersection(timeline, getScrolledDistanceSun, options)

  const item5Heading = () => {
    return (
      <>
        Enjoy your Solar Roof and Solar Mortgage
        <Superscript>TM</Superscript> savings
      </>
    )
  }
  return (
    <section className={styles.timeline}>
      <div className={styles.pagePadding}>
        <div className={styles.wrapper}>
          <div className={styles.header} ref={sky}>
            <h3 className={styles.heading}>See how it works</h3>
            <div className={styles.sunWrapper}>
              <div className={styles.skyMask}>
                <div className={styles.skyHeight}>
                  <div className={styles.sun} ref={sun}>
                    <div className={styles.sunDisk} ref={sunDisk} />
                  </div>
                </div>
              </div>
            </div>
            <div className={styles.horizon} ref={shadow}>
              <div className={styles.horizonShadow} />
            </div>
          </div>
          <div className={styles.track} ref={track}>
            <ol className={styles.list} ref={timeline}>
              <Item
                number="1"
                heading="Get pre-approved at Better.com"
                subhead="In 3 minutes"
              />
              <Item
                number="2"
                heading="Complete a fully digital financing process"
              />
              <Item
                number="3"
                heading="Tesla begins roof installation after your application is
              approved"
              />
              <Item
                number="4"
                heading="After closing, Better pays Tesla directly"
              />
              <Item number="5" heading={item5Heading()} />
              <Item
                number="6"
                badge="Bonus"
                heading="You can use up to 30% of the Solar Roof cost as an Investment
              Tax Credit the following year."
              />
            </ol>
          </div>
        </div>
      </div>
    </section>
  )
}

export default Timeline
